<template>

    <div>
        <div class="player-filter">

            <div class="wrapper">

                <div class="player-filter__type">
                    <label class="vh" for="eventMonthSelector">Month Selector</label>
                    <select ref="eventMonthSelector" id="eventMonthSelector" name="eventMonthSelector" v-model="selectedMonth">
                        <option value=""> All Dates</option>
                        <option v-for="(month, monthIndex) in this.allMonths" :value="month.value">
                            {{ month.label }}
                        </option>
                    </select>
                </div>

                <div class="player-filter__type">
                    <label class="vh" for="eventTypeSelector">Type Selector</label>
                    <select ref="eventTypeSelector" id="eventTypeSelector" name="eventTypeSelector" v-model="selectedType">
                        <option value=""> All Event Types</option>
                        <option v-for="(type, typeIndex) in this.types" :value="type.name">
                            {{ type.name }}
                        </option>
                    </select>
                </div>

            </div>

        </div>

        <div class="grid two wrapper">

                <events-list-item 
                    v-for="(event, eventIndex) in this.FilteredEvents" 
                    :eventItem="ensureEventHasID(event)" 
                    :key="event.post_id" 
                >
                </events-list-item>

        </div>

        <div class="wrapper">
            <div class="na" v-show="empty" style="margin-bottom: 40px">

                <h4 class="na__title" style="margin-bottom: 0">
                    No events match your criteria
                </h4>
            </div>
        </div>
    </div>

</template>


<script>
    import axios from 'axios';
    import ListItem from './ListItem.vue';

    export default {
        components: {
            'events-list-item': ListItem,
        },

        data() {
            return {
                types:[],
                events: null,
                allMonths:null,
                selectedMonth: "",
                selectedType:"",
                empty: false,
            }
        },
        created() {
        },
        mounted () {
            axios.get('/wp-json/events/v1/list')
                .then(response => {
                    this.types = response.data.terms;
                    
                    // Process events to ensure proper IDs
                    if (response.data.event && Array.isArray(response.data.event)) {
                        // Ensure all events have proper numeric IDs
                        this.events = response.data.event.map(event => {
                            // Ensure the numeric post_id is available and consistent
                            if (event.post_id) {
                                // Convert post_id to a numeric value if it's not already
                                const numericId = parseInt(event.post_id, 10);
                                if (!isNaN(numericId)) {
                                    event.post_id = numericId;
                                    // Also set the ID field to the same numeric value for consistency
                                    event.id = numericId;
                                }
                            }
                            return event;
                        });
                    } else {
                        this.events = response.data.event || [];
                    }

                    this.allMonths = this.period(this.events);
                })
                .catch(error => {
                    console.error('Error fetching events:', error);
                    this.events = [];
                    this.types = [];
                    this.allMonths = [];
                });

            let vm = this
            jQuery('#eventTypeSelector').select2({
                width: '100%'
            }).on('change', function () {
                vm.selectedType = this.value
            })

            jQuery('#eventMonthSelector').select2({
                width: '100%'
            }).on('change', function () {
                vm.selectedMonth = this.value
            })
        },
        watch:{
            FilteredEvents: function(newVal, oldVal) {

                if(this.FilteredEvents.length < 1){
                    this.empty = true;
                }else{
                    this.empty = false;
                }
            }

        },
        computed: {
            FilteredEvents: function () {

                let vm = this
                let items = this.events

                if(this.selectedType != 0){
                    items = items.filter(function(item){
                        var types = item.type
                        for (let i = 0; i < types.length; i++) {
                            if (vm.selectedType.includes(types[i].name)) {
                                return true;
                            }
                        }
                    })
                }

                if(this.selectedMonth){
                    return items.filter(function (item) {
                        const rawDate = String(item.acf.date || '');
                        const [month, day, year] = rawDate.split('/').map(Number);
                        if (!month || !year) {
                            return false;
                        }
                        const itemMonthKey = `${year}-${String(month).padStart(2, '0')}`;
                        return itemMonthKey === vm.selectedMonth;
                    }, this);
                }

                return items

            }
        },
        methods: {

            period(items) {

                const months = [];

                items.forEach((item) => {
                    const rawDate = String(item.acf.date || '');
                    const [month, day, year] = rawDate.split('/').map(Number);

                    if (!month || !year) {
                        return;
                    }

                    const monthKey = `${year}-${String(month).padStart(2, '0')}`;

                    // Check if the month already exists in the months array
                    const isMonthExists = months.some((m) => m.value === monthKey);

                    if (!isMonthExists) {
                        const dateObj = new Date(year, month - 1, 1);
                        const label = dateObj.toLocaleString('en-US', { month: 'long', year: 'numeric' }); // e.g. "January 2024"

                        const monthEntry = {
                            value: monthKey,
                            label: label,
                        };

                        months.push(monthEntry);
                    }

                });

                // Sort months chronologically
                months.sort((a, b) => a.value.localeCompare(b.value));

                return months;

            },
            ensureEventHasID(event) {
                // Make a copy of the event to avoid mutating the original
                const eventCopy = {...event};
                
                // Ensure the event has an ID
                if (!eventCopy.id && eventCopy.post_id) {
                    eventCopy.id = eventCopy.post_id;
                } else if (!eventCopy.post_id && eventCopy.id) {
                    eventCopy.post_id = eventCopy.id;
                }
                
                return eventCopy;
            }
        },
    }

</script>


